




































import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Comments from '@/store/modules/Comments';
import Decisions from '@/store/modules/Decisions';

const commentsModule = getModule(Comments);
const decisionModule = getModule(Decisions);

@Component({
    components: {},
})
export default class CommentFocusResource extends Vue {
    get selectedDecision() {
        return decisionModule.selectedDecision;
    }

    get selectedCommentResource() {
        return commentsModule.newSelectedCommentResource;
    }

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get singularViewpointLabel() {
        return decisionModule.singularViewpointLabel;
    }

    get singularChoiceLabel() {
        return decisionModule.singularChoiceLabel;
    }

    get singularFactorLabel() {
        return decisionModule.singularFactorLabel;
    }

    get factorName() {
        if (this.selectedCommentResource) {
            return this.selectedCommentResource.tertiaryResource.name;
        } else {
            return null;
        }
    }

    get choiceName() {
        if (
            this.selectedCommentResource &&
            this.selectedCommentResource.secondaryResource.type === 'CHOICE'
        ) {
            return this.selectedCommentResource.secondaryResource.name;
        } else {
            return null;
        }
    }

    get viewpointName() {
        if (
            this.selectedCommentResource &&
            this.selectedCommentResource.resource.type === 'VIEWPOINT'
        ) {
            return this.selectedCommentResource.resource.name;
        } else {
            return null;
        }
    }
}
